import { atom, atomFamily } from 'recoil';
import { TenantLifecycleStatus, SiteLifecycleStatus } from '../tenants/tenantService';

export const tenantsStatusFilterAtom = atom<TenantLifecycleStatus[]>({
  key: 'tenantsStatusFilter',
  default: [TenantLifecycleStatus.Active],
});

export const sitesStatusFilterAtom = atom<SiteLifecycleStatus[]>({
  key: 'sitesStatusFilter',
  default: [SiteLifecycleStatus.Active],
});

export const sitesTypeFilterAtom = atom<string[]>({
  key: 'sitesTypeFilter',
  default: [],
});

export const subscriptionsTenantsStatusFilterAtom = atom<TenantLifecycleStatus[]>({
  key: 'subscriptionsTenantsStatusFilter',
  default: [TenantLifecycleStatus.Active],
});

export const subscriptionsSiteStatusFilterAtom = atom<SiteLifecycleStatus[]>({
  key: 'subscriptionsSiteStatusFilter',
  default: [SiteLifecycleStatus.Active],
});

export const smsRecipientsTenantsStatusFilterAtom = atom<TenantLifecycleStatus[]>({
  key: 'smsRecipientsTenantsStatusFilter',
  default: [TenantLifecycleStatus.Active],
});

export const smsRecipientsSiteStatusFilterAtom = atom<SiteLifecycleStatus[]>({
  key: 'smsRecipientsSiteStatusFilter',
  default: [SiteLifecycleStatus.Active],
});

export const searchTextAtomFamily = atomFamily<string, string>({
  key: 'searchText',
  default: '',
});
